import { useSelector } from "react-redux";
import "../styles/modal.css";

export default function CustomMarketingStripe(props) {
  const direction = useSelector((state) => state.mode.direction);

  return (
    <div
      className="blue_green_linear_gradient_background dimantion_marketing_stripe basket-page-start-stripe"
      data-testid="basket-marketing-stripe"
      dir={direction}
      style={{
        position: "sticky",
        top: 0,
        display: "flex",
        alignItems: "center",
        height: "40px",
        minHeight: "40px",
        maxHeight: "40px",
        justifyContent: "flex-start",
        boxSizing: "border-box",
        gap: "8px",
        paddingInlineStart: "var(--container-margin-start, 4vw)",
        paddingInlineEnd: 0,
        zIndex: 11,
      }}
    >
      <img
        src={props.icon}
        width={17}
        height={17}
        style={{ flexShrink: 0 }}
      />
      <div
        className="font_md"
        style={{
          textAlign: "start",
          overflow: "hidden",
          minWidth: 0,
          maxWidth: "100%",
          flex: "0 1 auto",
          paddingInlineStart: "2px",
          paddingInlineEnd: "8px",
        }}
      >
        <p
          className="truncate text-start"
          style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
        >
          <span style={{ fontWeight: "bold" }}>{props.boldText}</span>{" "}
          {props.text}
        </p>
      </div>
    </div>
  );
}
